import { waitAsync } from '../utils';
import { Route } from 'react-router-dom';

const ModifyPointAction = "MODIFY_POINT";
const SavePointAction = "SAVE_POINT";
const ListPointsAction = "LIST_POINTS";
const Waiting = "WAITING_POINTS";

const initialState = {
    list: [],
    nowWainting: false,
    editing: null
};
export const actionCreators = {
    /**
     * ポイント設定情報の一覧を取得します。
     */
    listPoints: (token) => async (dispatch) => {
        const routeurl = `api/user/pointManagements/list`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    const list = resp.result;
                    dispatch({ type: ListPointsAction, list });
                    return list;
                } else {

                    throw new Error(resp.error_message || 'データ取得に失敗しました。');
                }
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * modify point
     */
    modifyPoint: (point) => async (dispatch) => {
        dispatch({ type: ModifyPointAction, point, nowWainting: false });
    },

    /**
     * 編集を保存します。
     */
    save: (token, point) => async (dispatch) => {
        var routeurl = `api/user/pointManagements`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(point)
            })

            var addNew = false;
            // IDがまだないものは新規登録とみなす
            if (!point.point_rule_id) {
                addNew = true;
            }

            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    dispatch({ type: SavePointAction, point: resp.result, addNew });
                    return resp.result;
                } else {
                    throw new Error(resp.error_message || '登録に失敗しました。');
                }
            } else {
                throw new Error('登録に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 編集用のモデルをロードします。
     */
    loadEditModel: (token, pointId) => async (dispatch) => {
        var routeurl = `api/user/pointManagements/edit`;

        if (pointId != null) {
            routeurl += `?id=${pointId}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })
            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    const point = resp.result;
                    dispatch({ type: ModifyPointAction, point });
                    return point;
                } else {
                    throw new Error(resp.error_message || 'データ取得に失敗しました。');
                }
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        }
        finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },
 }

export const reducer = (state, action) => {
    state = state || initialState;
    
    if (action.type === Waiting) {
        return {
            ...state,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ModifyPointAction) {
        return {
            ...state,
            editing: action.point,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListPointsAction) {
        return {
            ...state,
            list: action.list,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === SavePointAction) {
        if (action.addNew) {
            // 新規登録時の場合はリストに追加
            state.list.push(action.point);
        }
        else {
            // 変更の場合はリストを変更
            var idx = state.list.findIndex((o) => o.point_rule_id == action.point.point_rule_id);
            state.list[idx] = action.point;
        }
        return {
            ...state,
            editing: action.point
        };
    }
    return state;
}